module.exports = __webpack_public_path__ + "static/media/right-up-arrow-bg.bf0dd840.svg";